import { ModalActionKey } from "../../../actions/ActionKeys";
import { ModalAction } from "../../../actions/modal";

export const visible = (
  state: boolean = false,
  action: ModalAction
): boolean => {
  switch (action.type) {
    case ModalActionKey.SHOW_MODAL:
      return true;
    case ModalActionKey.HIDE_MODAL:
      return false;
    default:
      return state;
  }
};
